import type { Configuration } from '@azure/msal-browser';
import type { AppConfig } from '@/config/loadConfig';

export function buildMsalConfig(config: AppConfig): Configuration {
  return {
    auth: {
      clientId: config.msalClientId,
      authority: config.msalAuthority,
      redirectUri: config.msalRedirectUri,
      postLogoutRedirectUri: config.msalRedirectUri,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
  };
}

export function getLoginRequest(config: AppConfig): { scopes: string[] } {
  return {
    scopes: config.msalScopes,
  };
}
